module.exports = __webpack_public_path__ + "img/menu-outline.90528849.svg";